import cv from '../../assets/cv.pdf';
import { Modal, Flex, Button } from 'antd';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const CV = ({ isModalOpen, setIsModalOpen }) => {

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCVDownload = () => {
    // Open the CV in a new tab
    window.open(cv, '_blank');

    // Trigger the download
    const link = document.createElement('a');
    link.href = cv;
    link.download = 'Louis-Alleyne-CV.pdf';
    link.click();

    // Close the modal
    setIsModalOpen(false);
  };

  return (
    <Flex align='center' justify='center'>
       <Modal
        centered
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%',
        }}
      >
        <Flex vertical align='center' justify='center' style={{ height: '100%', gap: '20px' }}>
          <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
            <Viewer fileUrl={cv} />
          </Worker>
          <Button type='primary' onClick={handleCVDownload} >Download CV</Button>        
        </Flex>
      </Modal>
    </Flex>
  );
}

export default CV;